import { useEffect, useState } from 'react';

export const useResizeObserver = (element?: HTMLDivElement | null) => {
  const [resultHeight, setHeight] = useState(0);

  useEffect(() => {
    if (element) {
      const observer = new ResizeObserver((entries) => {
        const { height } = entries[0].target.getBoundingClientRect();
        setHeight(height);
      });
      observer.observe(element);
      return () => {
        observer.disconnect();
      };
    }
  }, [element]);

  return resultHeight;
};
